<template>
    <div class="thankYou-page">
        <div class="thankYou-pageContent">
            <div class="text-center">
                <h1 class="display-4 mb-4">{{header_text}}</h1>
                <p class="lead txt--l txt--off-white">
                    {{body_text}}
                </p>
                <hr class="border--bottom-gray border-top-0" />
                <p class="txt--ss">
                    Having trouble?
                    <a class="txt--primary" href="mailto:hello@piedparker.com?subject=Hello!">Contact us</a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "OperatorInvitation",
    data() {
        return {
            header_text: 'Validating.....',
            body_text: 'Hold on a second! we are validating your Invitation.',
            email: '',
            has_account: 0,
            uuid: '',
        }
    },
    created() {
        localStorage.clear();
        this.email = this.$route.query.email;
        this.has_account = parseInt(this.$route.query.has_account);
        this.uuid = this.$route.query.uuid;
        this.validateInvitation();
    },
    methods: {
        validateInvitation() {
            this.axios.post(window.hostname+'/api/auth/operator/validate-invitation',{
                email: this.email,
                uuid: this.uuid,
                has_account: this.has_account
            })
            .then(res=> {
                if(res.data.status) {
                    this.$toasted.show(res.data.message,{
                        icon: 'check-circle',
                        className: 'success-class'
                    });
                    if(res.data.valid == 1) {
                        this.$nextTick(()=> {
                            this.header_text = 'Redirecting...';
                            this.body_text = 'Your Invitation is validated. Hold on a second, we are redirecting you to login/signup!';
                        });
                        
                        if(res.data.has_account == 1) {
                            this.$router.push({name: 'OperatorLogin',params: {uuid: this.uuid}});
                        }
                        else {
                            this.$router.push({name: 'SignUp',params: {
                                uuid: this.uuid
                            }});
                        }
                    }
                    else {
                        this.header_text = 'Invitation Claimed...';
                        this.body_text = 'This invitation is already claimed!';
                        this.$router.push("/login");
                    }
                }
                else {
                    this.$toasted.show(res.data.message,{
                        icon: 'times-circle',
                        className: 'error-class'
                    });
                    this.$router.push('/login');
                }
            })
            .catch(err => {
                this.$toasted.show("Something went wrong. Please try again!",{
                    icon: 'times-circle',
                    className: 'error-class'
                });

                this.$router.push('/login');
            })
        }
    }
}
</script>